export default __webpack_public_path__ + "static/David.Miskimens_social-80534efda5b621f941053d8dec4c8c9f.jpg";